import { useEffect, useState } from 'react';
import { getCloudinaryUrl } from '../utils/cloudinary';
import { TRUSTED_PROFILES } from '../utils/trustedProfiles';

const optimizeProfileImage = (imageUrl) =>
  getCloudinaryUrl(imageUrl, {
    width: 192,
    height: 192,
    crop: 'fill',
    quality: 'auto',
    format: 'auto',
  }) || imageUrl;

const normalizeHandle = (rawHandle) => {
  const value = String(rawHandle || '').trim();
  if (!value) return '';
  return value.startsWith('@') ? value : `@${value}`;
};

const normalizeProfiles = (profiles) =>
  (Array.isArray(profiles) ? profiles : [])
    .map((profile) => {
      const handle = normalizeHandle(profile?.handle);
      const imageUrl = String(profile?.image_url || profile?.image || '').trim();
      if (!handle || !imageUrl) return null;
      return {
        handle,
        image: optimizeProfileImage(imageUrl),
        introVideoUrl: profile?.intro_video_url || null,
        introVideoPosterUrl: profile?.intro_video_poster_url || null,
        introVideoPublicId: profile?.intro_video_public_id || null,
      };
    })
    .filter(Boolean);

export default function useTrustedCarouselProfiles() {
  const [profiles, setProfiles] = useState(TRUSTED_PROFILES);

  useEffect(() => {
    let isMounted = true;

    const loadProfiles = async () => {
      try {
        const response = await fetch('/api/carousel/checkout-profiles');
        if (!response.ok) return;

        const data = await response.json();
        if (!data?.ok) return;

        const normalized = normalizeProfiles(data.profiles);
        if (!normalized.length) return;

        if (isMounted) {
          setProfiles(normalized);
        }
      } catch (_) {
        // Keep bundled fallback profiles when API is unavailable.
      }
    };

    loadProfiles();

    return () => {
      isMounted = false;
    };
  }, []);

  return profiles;
}
